import { ValueHelpers } from '@headless-workspace/utils';
import { LoyaltyConfigDTO } from './LoyaltyConfigDTO';
import { LoyaltyPointsPerCurrencyDTO } from './LoyaltyPointsPerCurrencyDTO';

export type BaseLoyaltyConfig = {
    isEnableOffers?: boolean;
    isEnableLoyaltyPoints: boolean;
    loyaltyProgramName?: string;
};

export type LoyaltyConfigsValue = Readonly<BaseLoyaltyConfig> & {
    loyaltyPointsPerCurrency?: number;
};

export const mapLoyaltyConfigsValue = (
    dto: LoyaltyConfigDTO,
    loyaltyPointsPerCurrency: LoyaltyPointsPerCurrencyDTO,
): LoyaltyConfigsValue => {
    return {
        isEnableOffers: dto.enableOffers,
        isEnableLoyaltyPoints: dto.enableLoyaltyPoints,
        loyaltyPointsPerCurrency: ValueHelpers.mapOptional(loyaltyPointsPerCurrency),
        loyaltyProgramName: dto.loyaltyProgramName,
    };
};
